export const PAGE_CONFIG_GLOBAL = "__PC_ANALYTICS_PAGE_CONFIG__";

declare global {
	interface Window {
		__PC_ANALYTICS_PAGE_CONFIG__?: Record<string, unknown>;
	}
}

export function readAnalyticsPageConfig(): Record<string, unknown> | undefined {
	if (typeof window === "undefined") return undefined;
	return window[PAGE_CONFIG_GLOBAL];
}
